export const simpleCoachMarkIDListing = [
  "firstRetryInEssay",
  "firstRetryInReview",
  "answeredFirstSecondLevelQuestion",
] as const;
export type SimpleCoachMarkID = typeof simpleCoachMarkIDListing[number];

export function isSimpleCoachMarkID(
  coachMarkID: CoachMarkID,
): coachMarkID is SimpleCoachMarkID {
  return (simpleCoachMarkIDListing as Readonly<string[]>).includes(coachMarkID);
}

export function isOverlayCoachMarkID(
  coachMarkID: CoachMarkID,
): coachMarkID is OverlayCoachMarkID {
  return (overlayCoachMarkIDListing as Readonly<string[]>).includes(
    coachMarkID,
  );
}

export const overlayCoachMarkIDListing = [
  "firstReviewAreaComplete",
  "firstLevelComplete",
] as const;
export type OverlayCoachMarkID = typeof overlayCoachMarkIDListing[number];

export const complexCoachMarkIDListing = [
  "firstReviewSessionComplete",
  "firstReviewBreak",
] as const;
export type ComplexCoachMarkID = typeof complexCoachMarkIDListing[number];

export type CoachMarkID =
  | SimpleCoachMarkID
  | OverlayCoachMarkID
  | ComplexCoachMarkID;
export const coachMarkIDListing = [
  ...simpleCoachMarkIDListing,
  ...overlayCoachMarkIDListing,
  ...complexCoachMarkIDListing,
] as (CoachMarkID)[];
